<div class="content-with-stepper-and-title front-document-scan">
  <div class="row">
    <div class="col-4 col-sm-8 col-md-12 col-lg-12 col-xl-12">
      <div class="title">
        <h1 id="frontDocTitle" [innerHTML]="copyService.copies.front_document_title">
        </h1>
      </div>

      <div class="animation">
        <lottie-animation-view id="frontDocAnimation" [options]="image" [width]="200"></lottie-animation-view>
      </div>
    </div>
  </div>
  <app-controls id="frontDocBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.front_document_next_btn" (next)="next()"></app-controls>
</div>
